<script setup>

import {embedHibridPlayerScript} from "@/components/Player/embed_player";
import {computed, onBeforeUnmount, onMounted, ref, watch} from "vue";
import store from "@/vuex/store";

const props = defineProps({
  options: {type: Object, default: {}},
})


const emit = defineEmits(['player', 'timeupdate', 'loaded'])

const localPlayer = ref(null)
const version = computed(() => import.meta.env.VUE_APP_PLAYER_SUBVERSION || 'v8.2.1')
const videoCurrentTime = computed(() => store.getters["video/getCurrentTime"])
const defaultOptions = computed(() => {
  console.log(store.getters["video/getVideo"])
  return {
    player: {
      poster: null,
      preload: 'auto'
    },
    controls: {
      enabled: true,
      aspectratio: "16:9"
    },
    stream: {
      url: store.getters["video/getVideoUrl"],
      type: "video/mp4",
    }
  }
})

const player_id = computed(() => `videojs-${Math.floor(Math.random() * 100000)}`)
const timeout = ref()
const loading = ref(true)
onMounted(async () => {
  embedHibridPlayerScript(version.value)
  check()
})

onBeforeUnmount(() => {
  clearTimeout(timeout.value)
  destroy()
})

function check() {
  if (typeof window.HiplayerLoader === "undefined") {
    timeout.value = setTimeout(check, 500);
  } else {
    initPlayer()
  }
}

function initPlayer() {
  let _options = Object.assign(defaultOptions.value, props.options)
  for (let key in _options) {
    if (_options[key] === null) {
      _options[key] = ``
    }
  }
  HiplayerLoader.setup(player_id.value, window.btoa(JSON.stringify(_options)))
  loading.value = false
  emit("loaded", true)
  bindHbPlayerEvents()
}

function bindHbPlayerEvents() {
  if (typeof window.HibridPlayer === "undefined" || !window.HibridPlayer.player) {
    setTimeout(bindHbPlayerEvents, 500);
  } else {
    localPlayer.value = window.HibridPlayer.player
    emit('player', localPlayer.value)
    localPlayer.value.on('timeupdate', () => emit('timeupdate', localPlayer.value.currentTime()))
  }
}


function destroy() {
  loading.value = true
  if (document.getElementById(`hiplayer-${version.value}-bundle`))
    document.getElementById(`hiplayer-${version.value}-bundle`).remove()
  const scripts = [...document.getElementsByTagName('hiplayerloader')]
  let links = document.querySelectorAll('link')
  scripts.forEach((element) => element.src.indexOf('hiplayer') !== -1 && element.remove())
  document.querySelectorAll('script').forEach(e => {
    if (e?.src.indexOf('hiplayer') != -1) e.remove()
  })
  document.querySelectorAll('head [class*="vjs-style"]').forEach(e => e.remove())
  document.querySelectorAll('[id*="hibridplayer_adtest_"]').forEach(e => e.remove())
  links.forEach((element) => (element.href.indexOf(`/${version.value}/hiplayer`) !== -1) && element.remove())
  links.forEach((element) => (element.href.indexOf(`/${version.value}/css/hiplayer`) !== -1) && element.remove())
  //
  delete window.HiplayerLoader
  delete window.HibridPlayer
  delete window.videojs
}

watch(videoCurrentTime, v => {
  if (!localPlayer.value) return
  localPlayer.value.currentTime(v)
})

</script>

<template>
  <div class="relative min-h-[240px]" style="aspect-ratio: 16/9">
    <div class="flex w-full h-full absolute top-0 left-0 justify-center items-center bg-gray-200 rounded-[4px]"
         v-if="loading">
      <p><i class="fa fa-spinner text-[32px] animate-spin text-blue-450"></i></p>
    </div>
    <div :id="player_id"></div>
  </div>
</template>
